import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { TierProgramDetail } from "@colab/shared";

// GET /api/admin/tiers/programs/:id — full TierProgramDetail aggregate
// (program + tiers + matrix rows + cells).
//
// Phase 7 sub-bucket 12. The matrix editor's single source of truth; the
// Phase 6 mutation hooks (useSetTierCell / useReorderTiers / useReorderRows
// / useUpdateRow / useUpdateTier) write optimistically against this key.
// `useAutosave` flush callbacks MUST re-read this cache at flush time and
// apply their mutator on top — debounced row-label + settings autosaves
// coexist with per-cell on-blur writes (sub-bucket 11 correctness lesson).
export function useProgram(id: string | undefined) {
  return useQuery<TierProgramDetail, ApiClientError>({
    queryKey: id ? queryKeys.tiers.program(id) : ["tiers", "program", "__missing__"],
    queryFn: () => apiFetch<TierProgramDetail>(`/admin/tiers/programs/${id}`),
    enabled: !!id,
  });
}
